import React from 'react';
import {connect} from 'react-redux';

const Checkout=({total_price})=>{
    return(
        <div className="checkout">
            <div className="row">
                <div className="col-12 d-flex justify-content-end">
                    <div className="total-block">
                        <div>
                            <span className="total-title">Total : </span>
                            <span className="total-price"> ${total_price}</span>
                        </div>
                        <button type="button" className="btn btn-primary btn-checkout">
                            <i className="fa fa-shopping-cart cart-icon"></i>
                            <span>Checkout</span></button>
                    </div> 
                </div>
            </div>
        </div>
    );
}
const mapStateToProps=({total_price})=>{
    return {total_price};
}

export default connect(mapStateToProps)(Checkout);